//import React from "@types/react";
import React from "react";
import GameSantaRun from "../../Components/Game/GameSantaRun";
import GameGiftCollect from "../../Components/Game/GameGiftCollect";
export const Days = [{
    id: 1, content:
        <>
            <h2>Employer Branding kisfilmsorozat – werk változat</h2>
            <p className={'text-brandDark lg:text-base'}>Nemrég ért véget a brand kampány, amelynek része volt egy
                kollégákkal készült kisfilm sorozat. Ennek a humoros werk filmjét láthatjátok most.</p>
            <div className={'hidden 2xl:flex justify-center my-4'}>
                <video width="560" controls>
                    <source src="cdn/videos/bakik.mp4"/>
                </video>
            </div>
            <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                <video width="500" controls>
                    <source src="cdn/videos/bakik.mp4"/>
                </video>
            </div>
            <div className={'flex justify-center my-4 md:hidden'}>
                <video width="100%" height="250" controls>
                    <source src="cdn/videos/bakik.mp4"/>
                </video>
            </div>
        </>
}, {
    id: 2, content:
        <>
            <h2>Programajánló</h2>
            <h3>Csepeli Jégpark</h3>
            <div className={"flex flex-col lg:flex-row gap-5"}>
                <p className={"text-brandDark"}>
                    A Csepeli Jégpark decemberben különösen hangulatos, igazi téli élményt kínáló helyszín, ahol minden
                    korosztály megtalálhatja a számára kellemes kikapcsolódást.<br/>
                    <br/>
                    A hatalmas, egymással összekötött
                    jégpályákon kényelmesen lehet korcsolyázni, akár teljesen kezdőként, akár rutinosabban csúszva. A
                    fények, a zene és a karácsonyi dekorációk nagyon meleg, ünnepi atmoszférát teremtenek, így a hely
                    tökéletes arra, hogy kicsit kiszakadjunk a hétköznapokból és ráhangolódjunk az ünnepekre. A park
                    területén több büfé is van, ahol forró csokival, teával vagy egyéb finomságokkal lehet megmelegedni
                    két
                    kör között.<br/>
                    <br/>
                    Ideális program munka utánra vagy hétvégére is, és akár családdal, akár barátokkal vagy
                    kollégákkal is igazán jó élményt ad.<br/>
                    <br/>
                    <a href="https://www.csepelijegpark.com/" target="_blank" className={"text-brandTertiary font-bold inline-block border-brandTertiary border rounded-lg p-3 hover:text-white hover:bg-brandTertiary"} rel="noreferrer">Irány a Jégpark!</a>
                </p>
                <img src="assets/days/nap2-jegpalya.jpg" alt="Csepeli Jégpark" className={"lg:w-1/2"} />
            </div>
        </>
},
    {
        id: 3, content:
            <>
                <h2>Főzős videók újra, közkívánatra</h2>
                <p className={'text-brandDark lg:text-base'}>
                    Közkívánatra újra közreadjuk az Alfa managementjének főzős videóit. Ebben a részben halászlé és
                    pizza készül.
                </p>
                <div className={"block md:flex justify-center gap-16"}>
                    <div>
                        <h4 className={"my-4 text-center font-sans not-italic"}>HALÁSZLÉ</h4>
                        <div className={'hidden 2xl:flex justify-center my-4'}>
                            <video width="560" controls>
                                <source src="cdn/videos/halaszle.mp4"/>
                            </video>
                        </div>
                        <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                            <video width="500" controls>
                                <source src="cdn/videos/halaszle.mp4"/>
                            </video>
                        </div>
                        <div className={'flex justify-center my-4 md:hidden'}>
                            <video width="100%" height="250" controls>
                                <source src="cdn/videos/halaszle.mp4"/>
                            </video>
                        </div>
                    </div>
                    <div>
                        <h4 className={"my-4 text-center font-sans not-italic"}>PIZZA</h4>
                        <div className={'hidden 2xl:flex justify-center my-4'}>
                            <video width="560" controls>
                                <source src="cdn/videos/pizza.mp4"/>
                            </video>
                        </div>
                        <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                            <video width="500" controls>
                                <source src="cdn/videos/pizza.mp4"/>
                            </video>
                        </div>
                        <div className={'flex justify-center my-4 md:hidden'}>
                            <video width="100%" height="250" controls>
                                <source src="cdn/videos/pizza.mp4"/>
                            </video>
                        </div>
                    </div>
                </div>
            </>
    },
    {
        id: 4, content:
            <>
                <h2>Főzős videók újra, közkívánatra</h2>
                <p className={'text-brandDark lg:text-base'}>
                    Közkívánatra újra közreadjuk az Alfa managementjének főzős videóit. Ebben a részben tatár beefsteak és narancsos-diós-mézes palacsinta készül.
                </p>
                <div className={"block md:flex justify-center gap-16"}>
                    <div>
                        <h4 className={"my-4 text-center font-sans not-italic"}><br className={'hidden md:inline'} />TATÁR BEEFSTEAK</h4>
                        <div className={'hidden 2xl:flex justify-center my-4'}>
                            <video width="560" controls>
                                <source src="cdn/videos/tatar_bifsztek.mp4"/>
                            </video>
                        </div>
                        <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                            <video width="500" controls>
                                <source src="cdn/videos/tatar_bifsztek.mp4"/>
                            </video>
                        </div>
                        <div className={'flex justify-center my-4 md:hidden'}>
                            <video width="100%" height="250" controls>
                                <source src="cdn/videos/tatar_bifsztek.mp4"/>
                            </video>
                        </div>
                    </div>
                    <div>
                        <h4 className={"my-4 text-center font-sans not-italic"}>NARANCSOS-DIÓS-MÉZES PALACSINTA</h4>
                        <div className={'hidden 2xl:flex justify-center my-4'}>
                            <video width="560" controls>
                                <source src="cdn/videos/palacsinta.mp4"/>
                            </video>
                        </div>
                        <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                            <video width="500" controls>
                                <source src="cdn/videos/palacsinta.mp4"/>
                            </video>
                        </div>
                        <div className={'flex justify-center my-4 md:hidden'}>
                            <video width="100%" height="250" controls>
                                <source src="cdn/videos/palacsinta.mp4"/>
                            </video>
                        </div>
                    </div>
                </div>
            </>
    },
    {
        id: 5, content: <>
            <GameSantaRun />
        </>
    },
    {
        id: 6, content: <>
            <h2>Mikulás a világ körül – különböző elnevezések</h2>

            <img src="assets/days/nap6-mikulas1.jpg" alt="Mikulás" className={'mb-2 md:float-right md:ml-5 md:w-1/2 md:mb-0'}/>

            <p>Játsszunk egyet: gondoltam egy személyre. Egy személyre, akinek nevét meghallva a karácsonyi csokis süti illata, a rénszarvas-szán csilingelése, az ajándékcsomagoló papír szakadása, a csillagszóró sistergése, a mézeskalács illatú gyertya csattogása és friss hó recsegő-ropogó hangja juthat eszedbe. Ha a Mikulásra gondoltál, biztos nem lelsz virgácsra idén a cipődben, hisz a válasz helyes.</p>

            <p>Sokunkban idéznek fel boldog emlékeket ezek az illatok, hangok és képek, amik a szemünk elé tárulnak olvasás közben, bárhol is legyünk a világban – s bárhogyan is nevezzék a világban az általunk Mikulásnak, vagy Télapónak ismert nagyszakállú, piros ruhás, kedves személyt.</p>

            <p>Általánosan elmondható, hogy a különböző elnevezések két csoportra oszthatóak. Az egyik csoport az eredetinek vélt, i.sz. 260-ban született Szent Miklós után eredeztethető – mint nálunk a Mikulás; míg a másik elnevezésben a karácsony illetve tél apjaként személyesítik meg – mint nálunk a Télapó.</p>

            <h3>Franciaország, Spanyolország, Portugália, Olaszország</h3>
            <p>
            Pére Noel (francia), Papa Noel (spanyol), Papai Noel (portugál), Babbo Natale(olasz) – Ezekben az országokban a karácsony apjaként tartják számon a Mikulást. Ő az, aki december 24-én, Szenteste napján vagy pedig december 25-én, karácsony első napján hagyja gondosan összekészített ajándékcsomagjait a karácsonyfa alatt. Sok családban a kis és nagygyermekek csak az éjféli mise után nyitják ki a meglepetéseket.</p>

            <h3>Törökország</h3>
            <p>
            Törökországban Noel Baba-ként, vagyis az előbbiekhez hasonlóan a karácsony apjaként nevezik, viszont azzal a különbséggel, hogy nem keresztény országként szinte sehol sem ünneplik a Mikulást s így a Karácsonyt sem. Az általunk ismert karácsonyfa ritkán kerül felállításra, akkor is csak 1 napra, mégpedig Újév napján. Az ajándékozás – azokban a családokban, ahol hagyománya van – is erre a napra csúszik. Így határozottan kijelenthetjük, hogy ha át szeretnénk élni más országban a karácsony szellemét, ne Törökországba utazzunk el akkortájt.</p>


            <h3>Németország</h3>
            <p>
            Weihnachtsmann – A kiejtést a kedves Olvasóra bízom. Törökország helyett nyugodt szívvel ajánlom Németországot, ha külföldön, ám ugyanolyan hagyományokkal szeretnénk a decemberi forgatagot átélni és megünnepelni. December 6-án a gyerekek kitakarítják a cipőjüket, majd kirakják az ablakba, hogy biztosan szemet szúrjon a Mikulásnak, amikor szánjával elrepül a ház előtt. Ezután pedig kezdődhet a karácsonyi listakészítés. A gyerekek összeírják, mire is vágynak a legjobban, hogy majd december 24-én vagy 25-én a Jézuska (das Christkind) elhozza nekik a vágyott ajándékokat.</p>

            <h3>Oroszország</h3>
            <p>
            Oroszországban legelterjedtebb az ortodox keresztény vallás, így természetesen felfedezhetünk különbségeket a Mikulás és Karácsony témakörében, ha Magyarország a kiindulási pontunk.</p>

            <p>Először is a dátum: nem érdemes elkezdeni decemberi dátumokra tippelni, ugyanis a karácsonyt január 7-én ünneplik ortodox naptár alapján – de egyes helyeken Újév napján is bekopogtathat az ajtón. A hagyomány szerint a gyerekek a karácsonyfát körülállva hívogatják Ded Moroz-t, (szabad fordításban: ,,Fagypapa”) s amikor a karácsonyi fények felgyúlnak, megjelenik Ded Moroz segítőjével, Snegurka-val (magyarul: Hópehelyhecske), az unokájával. Érdekesség még, hogy az északi-szláv hagyományoknak megfelelően a Mikulás (és segítője) piros öltözék mellett gyakran kék és ezüst színekben ábrázolják pásztorbotjával.</p>

            <img src="assets/days/nap6-mikulas2.jpg" alt="Santa" className={'mb-2 md:float-right md:ml-5 md:w-1/2 md:mb-0'}/>

            <p>Mint látható, különböző országok különböző kultúráiban másképp jelenik meg a Mikulás alakja, de egy valami biztos: függetlenül attól, hogy melyik országban élünk, milyen nyelven szólítjuk meg a Mikulást vagy éppen írunk neki levelet, ő ugyanolyan  örömmel fogja venni megkeresésünket és boldog mosolyt fog csalni a gyermekek arcára, hisz a boldogság nem foglalkozik a nyelv és kultúra kérdéskörével.</p>

            <p>
                A Mikulás alakja és az ehhez kapcsolódó hagyományok országról országra változnak. Míg Magyarországon a Mikulás december 6-án érkezik, és a jó gyerekeknek ajándékot, a rosszcsontoknak virgácsot hoz, másutt egészen másképp zajlik az ünnepség.
            </p>

            <p>
                <b>Tipp 2026-ra: Mentsd el a linket és intézz egy névre szóló Mikulás levelet a gyermekednek a jövő
                    évben.</b>
            </p>

            <p>
                Forrás: <a href="https://levelamikulastol.hu/mikulas-a-vilag-korul-kulonbozo-elnevezesek/" target="_blank">https://levelamikulastol.hu/mikulas-a-vilag-korul-kulonbozo-elnevezesek/</a>
            </p>

        </>
    },
    {
        id: 7, content: <>
            <h2>Programajánló</h2>
            <a href={"https://neprajz.hu/programok/csaladi-programok/2025/gyurjuk-ussuk-sussuk-adventi-meta-matine.html"}
               target={"blank"}>
                <img src="assets/days/nap7-programajanlo.jpg" alt="Filmajánló" className={"hidden md:block my-4 lg:max-w-[580px]"}/>
            </a>
            <a href={"https://neprajz.hu/programok/csaladi-programok/2025/gyurjuk-ussuk-sussuk-adventi-meta-matine.html"}
               target={"blank"}>
                <img src="assets/days/nap7-mobil-programajanlo.jpg" alt="Filmajánló" className={"md:hidden my-4"}/>
            </a>
        </>
    },
    {
        id: 8, content: <>
            <h2>Első 5 évünk a VIG cégcsoportban</h2>
            <p className={'text-brandDark lg:text-base'}>
                kisfilm sorozat (2021-2022)
            </p>
            <div className={"block md:flex justify-center gap-16"}>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2021_v6.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2021_v6.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2021_v6.mp4"/>
                        </video>
                    </div>
                </div>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2022_v4.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2022_v4.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2022_v4.mp4"/>
                        </video>
                    </div>
                </div>
            </div>
        </>
    },
    {
        id: 9, content:
            <>
                <h2>Bejgli vagy Zserbó?</h2>
                <p className={"text-brandDark"}>
                    Az karácsonyi desszert-dilemma. Ha választani kell(ene), akkor Bejgli vagy inkább Zserbó?
                </p>
            </>
    },
    {
        id: 10,
        content: <>
            <h2>Első 5 évünk a VIG cégcsoportban</h2>
            <p className={'text-brandDark lg:text-base'}>
                kisfilm sorozat (2023-2024)
            </p>
            <div className={"block md:flex justify-center gap-16"}>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2023_v6.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2023_v6.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2023_v6.mp4"/>
                        </video>
                    </div>
                </div>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2024_v2.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2024_v2.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2024_v2.mp4"/>
                        </video>
                    </div>
                </div>
            </div>
        </>
    },
    {
        id: 11, content:
            <>
                <h2>Rögtön puha mézes puszedli</h2>
                <p className={'text-brandDark lg:text-base'}>Illatos, fűszeres, mézes és pihe-puha ez a puszedli, a
                    karácsonyi asztalon kötelező helye van, ráadásul nem csak finom, mutatós is.</p>
                <h3>Recept</h3>
                <img src="assets/days/nap11-puszedli.jpg" alt="Puszedli"/>
                <h4 className={"text-brandDark my-4"}>Hozzávalók - 35 darabhoz</h4>
                <p><strong className={"text-brandDark"}>Puszedli:</strong></p>
                <div className={"block md:flex"}>
                    <p className={"text-brandDark w-80 mb-0 md:mb-4"}>
                        &bull; 50 dkg liszt<br/>
                        &bull; 1 tk. szódabikarbóna<br/>
                        &bull; 1 tk. fahéj<br/>
                        &bull; fél tk. szegfűszeg<br/>
                        &bull; negyed tk. gyömbér<br/>
                        &bull; negyed tk. szerecsendió<br/>
                    </p>
                    <p className={"text-brandDark"}>
                        &bull; 15 dkg méz<br/>
                        &bull; 15 dkg porcukor<br/>
                        &bull; 7,5 dkg vaj<br/>
                        &bull; 1 dl tej<br/>
                        &bull; 3 db tojássárgája
                    </p>
                </div>
                <p><strong className={"text-brandDark"}>Máz:</strong></p>
                <div className={"block md:flex"}>
                    <p className={"text-brandDark w-80 mb-0 md:mb-4"}>
                        &bull; 3 db tojásfehérje<br/>
                    </p>
                    <p className={"text-brandDark"}>
                        &bull; 15 dkg porcukor<br/>
                    </p>
                </div>
                <p className={"text-brandDark"}>Elkészítési idő: 25 perc | Előkészítési idő: 20 perc | Pihentetési idő:
                    2
                    óra</p>
                <h4 className={"text-brandDark mb-4"}>Elkészítés:</h4>
                <p className={"text-brandDark"}>
                    A lisztet és a szódabikarbónát szitáljuk tálba, keverjük el benne a fűszereket.<br/>
                    A mézet tegyük egy kis tálkába, majd a mikróban olvasszuk fel 30-45 másodperc alatt. Utána keverjük
                    habosra a cukorral és a vajjal, majd öntsük fel a tejjel. Keverjük bele a tojássárgákat is.<br/>
                    Forgassuk bele a lisztes keveréket, röbb részletben adagoljuk, míg össze nem áll a tészta, ekkor még
                    nagyon ragacsos.<br/>
                    Tegyük be a hűtőbe 1-2 órára pihenni, hogy könnyebben formázható legyen.<br/>
                    Közben melegítsük elő a sütőt 180 fokra. Béleljünk ki egy tepsit sütőpapírral.<br/>
                    Formázzunk a tésztából diónyi golyókat, majd tegyük őket a tepsibe. Toljuk a sütőbe 15-20 percre,
                    míg az aljuk aranybarna lesz.<br/>
                    Közben a tojásfehérjét kezdjük el verni vízgőz felett. Amikor habos a teteje, adjuk hozzá a
                    porcukrot. Nem kell belőle teljesen kemény habot verni, csak addig keverjük habverővel, míg sűrű,
                    kenhető massza nem lesz belőle. Kenjük le vele a puszedliket. Tegyük őket vissza a lekapcsolt sütőbe
                    száradni, vagy szobahőmérsékleten hagyjuk teljesen megszáradni, mielőtt kínálnánk.<br/>
                </p>
                <p className={'text-brandDark lg:text-sm lg:mt-8'}><strong className={"text-brandDark"}>Forrás: </strong><br/>
                    <a
                        href={"https://sobors.hu/receptek/mezes-puszedli-recept/"}
                        target={"blank"}>https://sobors.hu/receptek/mezes-puszedli-recept/</a>
                </p>
            </>
    },
    {
        id: 12,
        content: <>
            <h2>Karácsonyi kisfilm</h2>
            <p className={'text-brandDark lg:text-base'}>
                Bodor Péterrel
            </p>
            <div>
                <div className={'hidden 2xl:flex justify-center my-4'}>
                    <video width="560" controls>
                        <source src="cdn/videos/Alfa_karacsony6_Bodor_v1.mp4"/>
                    </video>
                </div>
                <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                    <video width="500" controls>
                        <source src="cdn/videos/Alfa_karacsony6_Bodor_v1.mp4"/>
                    </video>
                </div>
                <div className={'flex justify-center my-4 md:hidden'}>
                    <video width="100%" height="250" controls>
                        <source src="cdn/videos/Alfa_karacsony6_Bodor_v1.mp4"/>
                    </video>
                </div>
            </div>
    </>
    },
    {
        id: 13, content:
            <GameGiftCollect/>
    },
    {
        id: 14, content:
            <>
                <h2>Programajánló</h2>
                <a href={"https://zoobudapest.com/programok/vilag-allatai-lampion-fesztival/"}
                   target={"blank"}>
                    <img src="assets/days/nap14-programajanlo.jpg" alt="Filmajánló" className={"hidden md:block my-4 lg:max-w-[580px]"}/>
                </a>
                <a href={"https://zoobudapest.com/programok/vilag-allatai-lampion-fesztival/"}
                   target={"blank"}>
                    <img src="assets/days/nap14-mobil-programajanlo.jpg" alt="Filmajánló" className={"md:hidden my-4"}/>
                </a>
            </>
    },
    {
        id: 15, content:
            <>
                <h2>Karácsonyi kisfilm</h2>
                <p className={'text-brandDark lg:text-base'}>
                    Csépai Orsolyával
                </p>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_karacsony5_Csepai_v2.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_karacsony5_Csepai_v2.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_karacsony5_Csepai_v2.mp4"/>
                        </video>
                    </div>
                </div>
            </>
    },
    {
        id: 16, content:
            <>
                <h2>Karácsonyi kisfilm</h2>
                <p className={'text-brandDark lg:text-base'}>
                    Erdélyi Tamással
                </p>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_karacsony3_Erdelyi_v3.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_karacsony3_Erdelyi_v3.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_karacsony3_Erdelyi_v3.mp4"/>
                        </video>
                    </div>
                </div>
            </>
    },
    {
        id: 17, content:
            <>
                <h2>Karácsonyi kisfilm</h2>
                <p className={'text-brandDark lg:text-base'}>
                    Helli Józseffel
                </p>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_karacsony2_Helli_v3.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_karacsony2_Helli_v3.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_karacsony2_Helli_v3.mp4"/>
                        </video>
                    </div>
                </div>
            </>
    },
    {
        id: 18, content:
            <>
                <h2>Karácsonyi kisfilm</h2>
                <p className={'text-brandDark lg:text-base'}>
                    Szombat Tamással
                </p>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_karacsony4_Szombat_v2.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_karacsony4_Szombat_v2.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_karacsony4_Szombat_v2.mp4"/>
                        </video>
                    </div>
                </div>
            </>
    },
    {
        id: 19, content:
            <>
                <h2>Karácsonyi kisfilm</h2>
                <p className={'text-brandDark lg:text-base'}>
                    Zatykó Péterrel
                </p>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_karacsony1_Zatyko_v3.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_karacsony1_Zatyko_v3.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_karacsony1_Zatyko_v3.mp4"/>
                        </video>
                    </div>
                </div>
            </>
    },
    {
        id: 20, content:
            <>
                <h2>Karácsonyi karácsonyfa dekoráció</h2>
                <p className={'text-brandDark lg:text-base'}>Egyszerű, mégis mutatós tésztából készült karácsonyfa dekoráció az ünnepekre. A gyerekek is imádni fogják az elkészítési folyamatot.</p>
                <div className={'md:flex justify-center my-4 hidden'}>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/ffSgdaOMmp8?si=qS0LGUkxeUnIPUOB"
                            title="Christmas Animation - The Snowman" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen/>
                </div>
                <div className={'flex justify-center my-4 md:hidden'}>
                    <iframe width="100%" height="250" src="https://www.youtube.com/embed/ffSgdaOMmp8?si=qS0LGUkxeUnIPUOB"
                            title="Christmas Animation - The Snowman" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen/>
                </div>
            </>
    },
    {
        id: 21, content:
            <>
                <h2>Mit hozott nekem ez az év?</h2>
                <div className={"flex flex-col lg:flex-row gap-5"}>
                    <p>
                        Az év végéhez érve érdemes megállni egy pillanatra, és visszatekinteni arra
                        a sok élményre, változásra és tanulásra, amit magunkkal hoztunk.<br/>
                        <br/>
                        Sokszor csak rohanunk, és észre sem vesszük, mennyi minden történt
                        velünk – mennyi akadályt győztünk le, mennyi örömben volt részünk.<br/>
                        <br/>
                        Szánj most néhány percet magadra, és engedd, hogy rátekints arra az útra,
                        amit bejártál.<br/>
                        <br/>
                        <a href="cdn\apps\Alfa-A4-pdf-eves-kerdoiv-11-25-urlap.pdf" target="_blank" className={"text-brandTertiary font-bold inline-block mx-auto border-brandTertiary border rounded-lg p-3 hover:text-white hover:bg-brandTertiary"} rel="noreferrer">Letöltés</a>
                    </p>
                    <img src="assets/days/nap21.jpg" alt="Mit hozott nekem ez az év?" className={"lg:w-1/2"} />
                </div>
            </>
    },
    {
        id: 22, content:
            <>
                <h2>Első 5 évünk a VIG cégcsoportban</h2>
                <p className={'text-brandDark lg:text-base'}>
                    kisfilm sorozat (2025)
                </p>
                <div>
                    <div className={'hidden 2xl:flex justify-center my-4'}>
                        <video width="560" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2025_v3.mp4"/>
                        </video>
                    </div>
                    <div className={'md:flex 2xl:hidden justify-center my-4 hidden'}>
                        <video width="500" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2025_v3.mp4"/>
                        </video>
                    </div>
                    <div className={'flex justify-center my-4 md:hidden'}>
                        <video width="100%" height="250" controls>
                            <source src="cdn/videos/Alfa_VIG_ev_vegi_video_2025_v3.mp4"/>
                        </video>
                    </div>
                </div>
            </>
    },
    {
        id: 23, content:
            <>
                <h2>Karácsonyi zene</h2>
                <div className={'md:flex justify-center my-4 hidden'}>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/zbL4reaM_hY?si=BI1EcOlmPAh-JcUa"
                            title="Christmas Animation - The Snowman" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen/>
                </div>
                <div className={'flex justify-center my-4 md:hidden'}>
                    <iframe width="100%" height="250" src="https://www.youtube.com/embed/zbL4reaM_hY?si=BI1EcOlmPAh-JcUa"
                            title="Christmas Animation - The Snowman" frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen/>
                </div>
            </>
    },
    {
        id: 24, content:
            <>
                <img src="assets/days/nap24.jpg" alt="Filmajánló" className={"hidden md:block my-4 lg:max-w-[580px]"}/>
                <img src="assets/days/nap24-mobil.jpg" alt="Filmajánló" className={"md:hidden my-4"}/>
            </>
    },
]
